import React from 'react';
import DynamicDataTooltip from '../DynamicDataTooltip/DynamicDataTooltip';

interface UtilizationBarsProps {
  cpu?: string | number | null;
  ram?: string | number | null;
  cpuLabel?: string;
  ramLabel?: string;
}

const parseUtilization = (value?: string | number | null): number => {
  if (value === null || value === undefined || value === '') return 0;
  const num = typeof value === 'number' ? value : parseFloat(value.toString().replace('%', ''));
  return isNaN(num) ? 0 : Math.min(100, Math.max(0, num));
};

// Darker green/red scale: low usage -> green, high usage -> red.
const getUtilizationColor = (percent: number): string => {
  if (percent < 50) return '#15803d';
  return '#b91c1c';
};

const UtilizationBars: React.FC<UtilizationBarsProps> = ({ cpu, ram, cpuLabel = 'CPU Utilization', ramLabel = 'RAM Utilization' }) => {
  const cpuPct = parseUtilization(cpu);
  const ramPct = parseUtilization(ram);

  return (
    <DynamicDataTooltip data={{ cpu, ram }} fieldLabels={{ cpu: cpuLabel, ram: ramLabel }}>
      <div className="flex flex-col gap-1.5 w-32">
        <div className="flex items-center gap-2">
          <span className="text-[10px] text-gray-500 w-7 flex-shrink-0">CPU</span>
          <div className="flex-1 h-1.5 rounded-full overflow-hidden" style={{ backgroundColor: '#333' }}>
            <div
              className="h-full rounded-full transition-all"
              style={{ width: `${cpuPct}%`, backgroundColor: getUtilizationColor(cpuPct) }}
            />
          </div>
        </div>
        <div className="flex items-center gap-2">
          <span className="text-[10px] text-gray-500 w-7 flex-shrink-0">RAM</span>
          <div className="flex-1 h-1.5 rounded-full overflow-hidden" style={{ backgroundColor: '#333' }}>
            <div
              className="h-full rounded-full transition-all"
              style={{ width: `${ramPct}%`, backgroundColor: getUtilizationColor(ramPct) }}
            />
          </div>
        </div>
      </div>
    </DynamicDataTooltip>
  );
};

export default UtilizationBars;
